import type { ConnectionStatus } from '@/shared/types/workspace';

type PillTone = 'ok' | 'info' | 'warn' | 'off' | 'bad';
type StatusLook = { tone: PillTone; label: string };

export const CLAUDE_STATUS: Record<ConnectionStatus, StatusLook> = {
  CONNECTED: { tone: 'ok', label: 'Connected' },
  NOT_CONNECTED: { tone: 'off', label: 'Not connected' },
  WAITING: { tone: 'info', label: 'Checking the key' },
  KEY_REJECTED: { tone: 'bad', label: 'Key rejected' },
};

export const CODEX_STATUS: Record<ConnectionStatus, StatusLook> = {
  CONNECTED: { tone: 'ok', label: 'Connected' },
  NOT_CONNECTED: { tone: 'off', label: 'Not connected' },
  WAITING: { tone: 'info', label: 'Waiting for Codex' },
  KEY_REJECTED: { tone: 'bad', label: 'Secret rejected' },
};
